export const RADAR_MAPS_CONFIG = {
  sharableKey: "prj_live_pk_c32be99ba9cd8b075d23100be76f64a09d8c7a6b",
};
